module.exports = __webpack_public_path__ + "img/caution_06.80295248.png";